window.SMTX.calendly = (function () {
  const EMAIL_FIELD = '.calendly-module__email-field'
  const PARENT_MODULE = '.calendly-module'
  const BUTTON_ELEM = '.add-email-lead'
  const SERVICE_TYPE_CONTAINER = '.calendly-module__service-type'
  const SERVICE_TYPE_ERROR = '.service-type-error'
  if ($(PARENT_MODULE).length <= 0)  {
    return
  }

  // Get calendly country code, see if we need to remap it
  const localeMap = {
    'se': 'sv',
    'no': 'nb',
    'dk': 'da'
  }
  const localeLowerCase = window.SMTX.calendlySettings.country_code.toLowerCase()
  const momentLocale = localeMap[localeLowerCase] || localeLowerCase
  
  $('.calendly-module__preview-container__month-and-year').text(moment().locale(momentLocale).format('MMMM YYYY'))
  
  var hasInputEmailAlready = false
  if ($(PARENT_MODULE).length) {
    
    $(EMAIL_FIELD, PARENT_MODULE).on('keyup', onEmailFieldKeyup)
    $(EMAIL_FIELD, PARENT_MODULE).on('blur', function() { verifyCalendlyEmail(true) })
    $(BUTTON_ELEM, PARENT_MODULE).on('click', function(e) {
      window.SMTX.recaptcha.triggerRecaptcha(submitCalendlyEmail);
    });
    
    // Add radio button change handler
    $('input[name="service-type"]', PARENT_MODULE).on('change', function() {
      verifyCalendlyEmail();
    });
  }
  
  function isAnEmail(email){
    var isEmailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;

    if(!email.match(isEmailRegex)){
      return false;
    }
    
    return true;
  }
  
  async function isValidEmailAddress(email) {
    var invalidResults = ['invalidString', 'blacklisted', 'invalidDomain'];
    
    var result = await validateEmail(email)
    if (invalidResults.includes(result)) {
      return false
    }
    
    return true
  }
  
  function submitCalendlyEmail(e) {
    const calendlyEmail = $(EMAIL_FIELD, PARENT_MODULE).val()
    if(verifyCalendlyEmail()) {
      var iframeData;
      if (window.SMTX.PardotTracker) {
        const settings = getCurrentServiceSettings();
        var conv_url = window.location.href;

        var iframeData = {
          invitee_email: calendlyEmail,
          conversion_URL: conv_url,
        };
        
        var qryStr = jQuery.param(iframeData);
        var iframeSrc = 'https://info.semantix-group.com/' + settings.formHandlerId + '?' + qryStr;
  
        $(PARENT_MODULE).append($('<iframe src="' + iframeSrc + '" width="1" height="1"></iframe>'));
      }
      
      // Make sure we don't get a jumpy transition
      let windowTop = $(window).scrollTop()
      $("html, body").animate({ scrollTop:  $('.calendly-module').offset().top - $('.top-menu').outerHeight()}, 150)
      $('.calendly-module').css({minHeight: $('.calendly-module').height()})
      $('.calendly-module__content-wrapper').css({pointerEvents: 'none'}).fadeOut(300)

      showCalendly(calendlyEmail)
    }
  }
  
  function getCurrentServiceSettings() {
    const selectedService = $('input[name="service-type"]:checked').val();
    const settings = {
      calendlyUrl: window.SMTX.calendlySettings.calendlyUrl,
      formHandlerId: window.SMTX.calendlySettings.form_handler_id
    };

    if (selectedService === 'interpreting' && window.SMTX.calendlySettings.interpretingCalendlyUrl) {
      settings.calendlyUrl = window.SMTX.calendlySettings.interpretingCalendlyUrl;
      if (window.SMTX.calendlySettings.interpreting_form_handler_id) {
        settings.formHandlerId = window.SMTX.calendlySettings.interpreting_form_handler_id;
      }
    }

    return settings;
  }

  function showCalendly(calendlyEmail) {
    const settings = getCurrentServiceSettings();
    var checkCalendly = setInterval(function () {
      if (typeof Calendly !== 'undefined') {
        clearInterval(checkCalendly);
        Calendly.initInlineWidget({ 
          url: settings.calendlyUrl,
          parentElement: document.getElementById('calendly-container'), 
          prefill: { email: calendlyEmail }, 
          utm: {} 
        });
        
        $('#calendly-container').delay(0).fadeIn(300)
      }
    }, 100)
  }
  
  function onEmailFieldKeyup(e) {
    if (e.keyCode == 13) {
      window.SMTX.recaptcha.triggerRecaptcha(submitCalendlyEmail)
    } else {
      verifyCalendlyEmail()
    }
  }
  
  function verifyServiceType() {
    if ($(SERVICE_TYPE_CONTAINER).length === 0) {
      return true;
    }

    const selectedService = $('input[name="service-type"]:checked').val();
    if (!selectedService) {
      $(SERVICE_TYPE_ERROR).show();
      return false;
    }
    
    $(SERVICE_TYPE_ERROR).hide();
    return true;
  }

  function getEmailFieldValue() {
    return $(EMAIL_FIELD, PARENT_MODULE).val();
  }

  function updateEmailFieldState(isError) {
    $(EMAIL_FIELD, PARENT_MODULE).removeClass('disabled loading');
    if (isError) {
      $(EMAIL_FIELD, PARENT_MODULE).addClass('has-error');
      $(EMAIL_FIELD, PARENT_MODULE).focus();
    } else {
      $(EMAIL_FIELD, PARENT_MODULE).removeClass('has-error');
    }
  }

  function updateButtonState(isEnabled) {
    if (isEnabled) {
      $(BUTTON_ELEM, PARENT_MODULE).removeClass('disabled');
    } else {
      $(BUTTON_ELEM, PARENT_MODULE).addClass('disabled');
    }
  }

  async function verifyCalendlyEmail(isBlurred) {
    isBlurred = isBlurred || false
    
    $(EMAIL_FIELD).addClass('disabled loading')
    const emailValue = getEmailFieldValue();
    
    if(!hasInputEmailAlready) {
      // Check if user has input a correctly formatted email
      hasInputEmailAlready = isAnEmail(emailValue)
    }
    
    const isValidEmail = await isValidEmailAddress(emailValue)
    const isValidServiceType = await verifyServiceType();
    
    if (emailValue && isValidEmail) {
      // Valid email
      updateEmailFieldState(false);
      updateButtonState(isValidServiceType);
      return true;
    } else {
      // Invalid email
      if (hasInputEmailAlready || isBlurred) {
        // Has input an email previously, display errors
        console.log('has input already an email, show errors!');
        updateEmailFieldState(true);
        updateButtonState(false);
        return false;
      } else {
        // Has yet to input an initial email, don't display errors
        updateEmailFieldState(false);
        return false;
      }
    }
  }
})()
